export function lifecycleBannerSeverityClass(severity: string | null | undefined): string {
    switch (`${severity ?? 'info'}`.toLowerCase()) {
        case 'error':
            return 'lifecycle-banner--error';
        case 'warning':
            return 'lifecycle-banner--warning';
        case 'promo':
            return 'lifecycle-banner--promo';
        default:
            return 'lifecycle-banner--info';
    }
}
